import { useState, useEffect, useCallback } from 'react';
import { container } from '@/di';
import { TYPES } from '@/di/tokens';
import { ListTicketsAction } from '@/application/actions/support/ListTicketsAction';
import { UpdateTicketAction } from '@/application/actions/support/UpdateTicketAction';
import type { SupportTicketDTO, UpdateTicketDTO } from '@/domain/repositories/ISupportTicketRepository';

export const useTickets = (tenantId?: string) => {
  const [tickets, setTickets] = useState<SupportTicketDTO[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const load = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const action = container.get<ListTicketsAction>(TYPES.ListTicketsAction);
      const result = await action.execute(tenantId);
      setTickets(result);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Error al cargar tickets'));
    } finally {
      setIsLoading(false);
    }
  }, [tenantId]);

  useEffect(() => {
    load();
  }, [load]);

  const update = useCallback(async (id: string, data: UpdateTicketDTO): Promise<SupportTicketDTO> => {
    const action = container.get<UpdateTicketAction>(TYPES.UpdateTicketAction);
    const updated = await action.execute(id, data);
    setTickets(prev => prev.map(t => (t.id === updated.id ? updated : t)));
    return updated;
  }, []);

  return { tickets, isLoading, error, refetch: load, update };
};
